import React from 'react';

import { colors } from '@ovpn-ui/styles';
import { Button, Text } from '@ovpn-ui/core';
import { AlertTriangle } from '@ovpn-ui/icons';

import { Wrapper } from './ErrorBoundary.styles';

const pageReloadRegex = /^#updated:(\d)$/;

export class ErrorBoundary extends React.Component<{
    children: JSX.Element | JSX.Element[];
    onError?: (e: Error) => void;
}> {
    state = { error: undefined };

    componentDidCatch(error: Error) {
        // old reference to *.chunk.js filed has caused file loading error,
        // let's try to reload page forcing to clear cache
        // max try count: 5
        if (error?.name === 'ChunkLoadError') {
            const reloadHash = window.location.hash || '#updated:0';
            const match = reloadHash.match(pageReloadRegex);
            const reloadCount = Number(match?.[1] ?? 0);

            if (reloadCount < 5) {
                window.location.hash = `updated:${reloadCount + 1}`;
                window.location.reload();
                return;
            }
        }

        if (this.props.onError) {
            this.props.onError(error);
        }

        this.setState({ error });
    }

    handleBtnClick = () => {
        try {
            const zeApi = (window as any).zE;
            zeApi(zeApi.widget, 'open');
        } catch {
            // eslint-disable-next-line no-console
            console.warn('failed to open zendesk chat');
        }
    };

    render() {
        const { error } = this.state;
        const { children } = this.props;

        if (!error) {
            return children;
        }

        return (
            <Wrapper>
                <div className="empty-icon">
                    <AlertTriangle color={colors.red} />
                </div>
                <Text variant="displaySm" weight="semiBold" color={colors.neutralTextTitle}>
                    Sorry! Something Went Wrong
                </Text>
                <Text variant="textMd" color={colors.neutralTextSubtitle}>
                    Please refresh your page to try again.
                    <br />
                    If this issue is reproduced, please send us a feedback.
                </Text>
                <Button variant="primary" onClick={this.handleBtnClick} mt={20}>
                    Report Feedback
                </Button>
            </Wrapper>
        );
    }
}
